import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * NavigationProgress
 *
 * Thin top progress bar + soft fade backdrop that renders during route
 * changes. Addresses the "white screen on back-navigation" problem without
 * touching individual pages. Renders for ~500ms on every pathname change.
 */
const NavigationProgress = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 500);
    return () => clearTimeout(t);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="navigation-progress"
      className="fixed top-0 left-0 right-0 h-0.5 z-[9999] pointer-events-none"
    >
      <div
        className="h-full bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-400"
        style={{
          width: '100%',
          animation: 'nav-progress-slide 500ms ease-out forwards',
          transformOrigin: 'left',
        }}
      />
      <style>{`
        @keyframes nav-progress-slide {
          0% { transform: scaleX(0); opacity: 0.9; }
          60% { transform: scaleX(0.7); opacity: 1; }
          100% { transform: scaleX(1); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default NavigationProgress;
